export enum DeviceActions {
    SET_APP_ORIENTAION = "SET_APP_ORIENTAION"
}


